import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { CheckboxAngularModule } from 'rev-shared/ui/checkbox/CheckboxAngular.Module';
import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { ValidationAngularModule } from 'rev-shared/ui/validation/ValidationAngular.Module';
import { ValidationModule } from 'rev-shared/util/directives/form/validation/Validation.AngularModule';
import { VbProfilePictureModule } from 'rev-shared/ui/profile/VbProfilePicture.Module';
import { VbUiHtmlEditorComponent } from 'rev-shared/htmlEditor/VbUiHtmlEditor.Component';

import { VideoReviewAlertEntryComponent } from './VideoReviewAlertEntry.Component';
import { VideoReviewManualCommentEntryComponent } from './VideoReviewManualCommentEntry.Component';
import { VideoReviewManualCommentInputComponent } from './VideoReviewManualCommentInput.Component';
import { VideoReviewReplyEntryComponent } from './VideoReviewReplyEntry.Component';
import { VideoReviewReplyInputComponent } from './VideoReviewReplyInput.Component';

@NgModule({
	declarations: [
		VideoReviewAlertEntryComponent,
		VideoReviewReplyInputComponent,
		VideoReviewManualCommentEntryComponent,
		VideoReviewReplyEntryComponent,
		VideoReviewManualCommentInputComponent
	],
	exports: [
		VideoReviewAlertEntryComponent,
		VideoReviewManualCommentEntryComponent,
		VideoReviewManualCommentInputComponent
	],
	imports: [
		ButtonsAngularModule,
		CommonModule,
		DateAngularModule,
		FormsModule,
		CheckboxAngularModule,
		TranslateModule,
		VbProfilePictureModule,
		ValidationAngularModule,
		VbUiHtmlEditorComponent,
		TooltipModule,
		ValidationModule
	]
})
export class VideoReviewModule { }
